import { styled, Switch, SwitchProps } from '@mui/material'

const IOSSwitch = styled((props: SwitchProps) => (
	<Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
	width: 61,
	height: 34,
	padding: 0,
	overflow: 'inherit',
	alignItems: 'center',
	'& .MuiSwitch-switchBase': {
		padding: 1,
		'&.Mui-checked': {
			transform: 'translateX(30px)',
			color: theme.palette.common.white,
			'& + .MuiSwitch-track': {
				backgroundColor: theme.palette.primary.main,
				opacity: 1,
				border: 'none'
			},
			'&.Mui-disabled + .MuiSwitch-track': {
				opacity: 0.5
			}
		},
		'&.Mui-focusVisible .MuiSwitch-thumb': {
			color: theme.palette.primary.main,
			border: '6px solid #fff'
		}
	},
	'& .MuiSwitch-thumb': {
		width: 30,
		height: 30,
		marginTop: 1
	},
	'& .MuiSwitch-track': {
		borderRadius: 25,
		backgroundColor: '#D1D8DB',
		opacity: 1,
		transition: theme.transitions.create(['background-color'])
	}
}))

export default IOSSwitch